var Utilities = function() {};

Utilities.prototype.getQueryString = function(url, name, defaultValue) {
    var urlObj = new URL(url);
    const result = urlObj.searchParams.get(name);
    if(result == undefined) {
        return defaultValue;
    } else {
        return result;
    }
};

Utilities.prototype.replaceQueryStringValue = function(url, name, value, ignoreValues = []) {
    const urlObj = new URL(url);

    if (ignoreValues.includes(value)) {
        urlObj.searchParams.delete(name);
    } else {
        urlObj.searchParams.set(name, value);
    }

    return urlObj.href;
};

function createNonEmptyQueryString(query, ...queryParams) {
    let queryString = "";
    let escapedQuery = Utilities.prototype.escapeSpecialCharacters(query);

    if (escapedQuery) queryString += `q=${escapedQuery}`;

    for (let i = 0; i < queryParams.length; i++) {
        if (!queryParams[i]) continue;

        if (!escapedQuery && i === 0) {
            queryString += queryParams[i];
        } else {
            queryString += `&${queryParams[i]}`;
        }
    }
    return queryString;
}

/**
 * This is a client side API function.
 * @param {T} html 
 * @param {*} title 
 * @param {*} url 
 */
Utilities.prototype.updateBrowserHistoryUrl = function(html, title, url) {
    window.history.pushState({"html":html,"pageTitle":title},"", url);
};


Utilities.prototype.formatDateString = function(str) {
    try{
        if(str) {
            var date = new Date(str);
            return date.toLocaleDateString();
        } else {
            return str;
        }
    } catch(error) {
        return str;
    }
};


Utilities.prototype.formatDateMonthString = function(str) {
    try{
        if(str) {
            var date = new Date(str)
            return date.toDateString().slice(4);
        } else {
            return str;
        }
    } catch(error) {
        return str;
    }
};

Utilities.prototype.getPath = function() {
    let path = window.location.pathname.replace("/", "");
    if(path === ""){return "home"};
    return path;
};

Utilities.prototype.formatDescription = function(description, cardLayout) {
    if(typeof(description) === "string") {
        var result = description.replace(/\n/gi, "");
        result = result.replace(/<\/?br\s?\/?>/gi, "\n");
        result = result.replace(/<\/?[^>]*\/?>/gi, "");
        result = result.trim();
        
        if(cardLayout == "grid") {
            result = result.replace(/\n+/gi, "<br />");
        }
        
        return result;
    } else {
        return description;
    }
};

Utilities.prototype.escapeSpecialCharacters = function(query) {
    // sometimes we get q= in here... can't figure out how to get rid of it.
    if(query.indexOf("q=") == 0){
        let realQ = query.substring(2);
        let encode = encodeURIComponent(realQ);
        return ('q='+encode)
    } else {
        return encodeURIComponent(query);
    }
};

Utilities.prototype.hasSpecialCharacters = function(text, isQuery = false) {
    return false; // turn off
    //return  /[~!@%&_+=:"<>\[\];',.`^#()?|$\{\}\\\/]/gi.test(text);
};

function encodeParentheses(uri) {
    if(!uri) return uri;

    return uri.replaceAll(/[()]/g, (match) => `%${match.charCodeAt(0).toString(16).toUpperCase()}`);
}

function encodeUriWithParentheses(uri) {
    return encodeParentheses(encodeURIComponent(uri));
}

Utilities.prototype.getCookie = function(cname) {
    let decodedCookie = decodeURIComponent(document.cookie).split(";").reverse().find(x => {x = x.trim(); return x.includes(`${cname}=`)});

    if(decodedCookie){
        return decodedCookie.substring(decodedCookie.indexOf("=")+1)
    }

    return false;
}

Utilities.prototype.setCookie = function(cname) {
    document.cookie = `${cname}; path=/`;
}

Utilities.prototype.deleteCookie = function(cname) {
    document.cookie = `${cname}=; expires = Thu, 01 Jan 1970 00:00:00 GMT"; path=/`; 
}

function delay(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

function isOlderThan(timestamp, ms) {
    if (!timestamp || !ms) return false;

    const date = new Date(timestamp);
    const now = new Date();
    const diffInMs = now - date;
    return diffInMs > ms;
}

module.exports = new Utilities();

module.exports.createNonEmptyQueryString = createNonEmptyQueryString;
module.exports.encodeParentheses = encodeParentheses;
module.exports.encodeUriWithParentheses = encodeUriWithParentheses;
module.exports.delay = delay;
module.exports.isOlderThan = isOlderThan;
